import React from "react";
import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <Link
      to="/"
      className="
        flex items-center gap-2
        font-extrabold tracking-widest
        text-[#D14670]
        hover:opacity-90 transition
      "
    >
      {/* LOGO IMAGE */}
      <img
        src="/logo.jpeg"
        alt="ANE CROCHET Logo"
        className="h-8 w-8 object-contain"
      />

      {/* BRAND NAME */}
      <span className="text-sm sm:text-base">
        ANE CROCHET
      </span>
    </Link>
  );
}
